import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { GlobalContext } from '../GlobalContext';
import logo from '../assets/logo-all.png';

export default function Header({ isAuth = false }) {
  const { dispatch } = useContext(GlobalContext);
  return (
    <header className="navbar navbar-expand-md navbar-light d-print-none">
      <div className="container-xl">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbar-menu"
          aria-controls="navbar-menu"
          aria-expanded="false"
          aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" />
        </button>
        <h1 className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
          <Link
            className="w-100"
            to="/">
            <img
              src={logo}
              alt="logo"
              className="w-100"
            />
          </Link>
        </h1>
        {isAuth && (
          <>
            <div
              className="collapse navbar-collapse"
              id="navbar-menu">
              <div className="d-flex flex-column flex-md-row flex-fill align-items-stretch align-items-md-center">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/dashboard">
                      <span className="nav-link-title">Dashboard</span>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/player-list">
                      <span className="nav-link-title">Players</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="btn-list">
              <button
                className="btn"
                onClick={() => dispatch({ type: 'SIGNOUT' })}>
                Log Out
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
}
